import { render, staticRenderFns } from "./CoursesGrid.vue?vue&type=template&id=3286b0da&scoped=true"
import script from "./CoursesGrid.vue?vue&type=script&lang=js"
export * from "./CoursesGrid.vue?vue&type=script&lang=js"
import style0 from "./CoursesGrid.vue?vue&type=style&index=0&id=3286b0da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3286b0da",
  null
  
)

export default component.exports